module.exports = __webpack_public_path__ + "img/SES_280330025.785c40a6.jpg";